import styled from 'styled-components'
import Section, { Panel, SectionPanels } from './Section'
import { t, tStr } from '@utils/lang'

const InfoSection = styled(Section)`
  background: var(--themeColorBetaBgBrown);
  ul li {
    color: var(--themeColorBetaSecondary);
  }
`
const Icon = styled.svg`
  --primaryColor: var(--themeColorBluePrimary);
`
// Keeping these icons here because they are one offs and should not be used elsewhere
const PhoneIcon = () => (
  <Icon width="38" height="48" viewBox="0 0 38 48" fill="none">
    <path
      d="M27.079 24.9959C24.8916 24.9959 23.1133 23.2176 23.1133 21.0302C23.1133 18.8428 24.8916 17.0645 27.079 17.0645C29.2664 17.0645 31.0447 18.8428 31.0447 21.0302C31.0447 23.2176 29.2664 24.9959 27.079 24.9959Z"
      fill="var(--primaryColor)"
    />
    <path
      d="M27 11.5498C32.1891 11.5498 36.4502 15.8533 36.4502 21.2295C36.4502 23.7798 35.3384 26.5722 33.4648 29.5293C31.7204 32.2826 29.4031 35.0399 26.9863 37.7129C24.7115 35.2415 22.4073 32.4875 20.6396 29.6924C18.7238 26.6628 17.5498 23.7621 17.5498 21.2295C17.5498 15.8533 21.8109 11.5498 27 11.5498Z"
      stroke="var(--primaryColor)"
      strokeWidth="3.1"
    />
    <path
      d="M23.8594 2.42188C26.3455 2.5481 28.3223 4.60458 28.3223 7.12207V10.584H25.2227V7.12207C25.2227 6.23544 24.5038 5.51582 23.6172 5.51562H4.70605C3.8193 5.51562 3.09961 6.23532 3.09961 7.12207V42.8428C3.09961 43.7295 3.81931 44.4482 4.70605 44.4482H23.6172C24.5038 44.448 25.2227 43.7294 25.2227 42.8428V37.4268H28.3223V42.8428C28.3223 45.3603 26.3455 47.4158 23.8594 47.542L23.6172 47.5488H4.70605L4.46387 47.542C1.97738 47.4162 0 45.3605 0 42.8428V7.12207C0 4.60431 1.97737 2.54769 4.46387 2.42188L4.70605 2.41602H23.6172L23.8594 2.42188Z"
      fill="var(--primaryColor)"
    />
    <path d="M9.70703 8.97852H18.6003" stroke="var(--primaryColor)" strokeWidth="3.1" strokeLinecap="round" />
    <path d="M6.18555 39.4492H22.1669" stroke="var(--primaryColor)" strokeWidth="3.1" strokeLinecap="round" />
  </Icon>
)
const TipsIcon = () => (
  <Icon width="44" height="50" viewBox="0 0 44 50" fill="none">
    <path
      d="M29.924 40.6995C26.6564 40.6995 24 38.043 24 34.7755C24 31.508 26.6564 28.8516 29.924 28.8516C33.1915 28.8516 35.8479 31.508 35.8479 34.7755C35.8479 38.043 33.1915 40.6995 29.924 40.6995Z"
      fill="var(--primaryColor)"
    />
    <path d="M8.45312 7.99219H24.3387" stroke="var(--primaryColor)" strokeWidth="3" strokeLinecap="round" />
    <path d="M8.45312 12.9922H24.3387" stroke="var(--primaryColor)" strokeWidth="3" strokeLinecap="round" />
    <path d="M8.45312 17.9922H17.2143" stroke="var(--primaryColor)" strokeWidth="3" strokeLinecap="round" />
    <rect
      x="2"
      y="1.84961"
      width="28.7779"
      height="21.3574"
      rx="4.95741"
      stroke="var(--primaryColor)"
      strokeWidth="3"
    />
    <path
      d="M30.3149 13.1768C40.4062 13.6014 44.0005 27.2485 44.0005 34.9609L43.9956 35.3271C43.8016 42.9927 37.5335 49.1474 29.8296 49.1475L29.4634 49.1426C21.8063 48.9482 15.6587 42.6733 15.6587 34.9609C15.6587 31.6342 16.3285 27.2037 17.8989 23.2061H21.1528C19.4159 27.0419 18.6587 31.6275 18.6587 34.9609C18.6587 41.142 23.6633 46.1475 29.8296 46.1475C35.9958 46.1474 41.0005 41.142 41.0005 34.9609C41.0005 31.4107 40.1414 26.4402 38.1548 22.4678C36.169 18.4969 33.4421 16.1671 29.8296 16.167C29.8126 16.167 29.7957 16.1679 29.7788 16.168V13.168C29.7957 13.1679 29.8126 13.167 29.8296 13.167L30.3149 13.1768Z"
      fill="var(--primaryColor)"
    />
  </Icon>
)
const CommunityIcon = () => (
  <Icon width="43" height="50" viewBox="0 0 43 50" fill="none">
    <path
      d="M35.0391 24.3242C36.9613 24.3242 38.5202 25.8825 38.5205 27.8047C38.5205 29.7271 36.9615 31.2861 35.0391 31.2861C33.1169 31.2859 31.5586 29.7269 31.5586 27.8047C31.5589 25.8827 33.117 24.3245 35.0391 24.3242Z"
      fill="var(--primaryColor)"
      stroke="var(--primaryColor)"
      strokeWidth="2.32055"
    />
    <path
      d="M7.97607 24.3242C9.89832 24.3242 11.4573 25.8825 11.4575 27.8047C11.4575 29.7271 9.89848 31.2861 7.97607 31.2861C6.05389 31.2859 4.49561 29.7269 4.49561 27.8047C4.49587 25.8827 6.05405 24.3245 7.97607 24.3242Z"
      fill="var(--primaryColor)"
      stroke="var(--primaryColor)"
      strokeWidth="2.32055"
    />
    <circle
      cx="21.1946"
      cy="26.4981"
      r="4.46135"
      fill="var(--primaryColor)"
      stroke="var(--primaryColor)"
      strokeWidth="2.32055"
    />
    <path
      d="M35.0312 30.1667C39.4322 30.1667 42.9997 33.7347 43 38.1355V43.3425C43 45.1476 41.5365 46.6111 39.7314 46.6111H30.5527V43.4646H39.7314C39.7988 43.4646 39.8535 43.4099 39.8535 43.3425V38.1355C39.8532 35.4723 37.6945 33.3132 35.0312 33.3132C32.3683 33.3135 30.2093 35.4725 30.209 38.1355V38.1472C29.8034 36.6862 29.0546 35.3689 28.0527 34.2878C29.4101 31.8313 32.0261 30.167 35.0312 30.1667Z"
      fill="var(--primaryColor)"
    />
    <path
      d="M21.1777 31.438C25.4893 31.438 28.9851 34.9331 28.9854 39.2446V45.9448C28.9854 46.8811 28.2263 47.6401 27.29 47.6401H15.0664C14.1302 47.6401 13.3711 46.8811 13.3711 45.9448V39.2446C13.3713 34.9332 16.8663 31.4382 21.1777 31.438Z"
      stroke="var(--primaryColor)"
      strokeWidth="3.14634"
    />
    <path
      d="M7.96875 30.1667C10.5202 30.1667 12.7895 31.3678 14.248 33.2332C13.4562 34.1027 12.8273 35.1227 12.4053 36.2439C11.6697 34.5211 9.96047 33.3132 7.96875 33.3132C5.30557 33.3133 3.14677 35.4724 3.14648 38.1355V43.3425C3.14648 43.4099 3.20115 43.4646 3.26855 43.4646H11.8057V46.6111H3.26855L3.10059 46.6072C1.37349 46.5198 0 45.0913 0 43.3425V38.1355C0.000283744 33.7347 3.56789 30.1668 7.96875 30.1667Z"
      fill="var(--primaryColor)"
    />
    <path
      d="M24.8645 2.28003C23.9311 2.28003 23.095 2.69013 22.4353 3.35096L21.3149 4.5421C21.2503 4.61071 21.1413 4.61071 21.0768 4.54209L19.9565 3.35082C19.3153 2.66902 18.4533 2.28003 17.5276 2.28003C15.6209 2.28003 14.0874 3.9279 14.0874 5.94467C14.0874 9.0764 17.6718 11.8754 20.0964 14.0518C20.7135 14.6057 21.677 14.6057 22.2942 14.0518C24.7195 11.8751 28.3049 9.07655 28.3049 5.94467C28.3049 3.92796 26.7712 2.28003 24.8645 2.28003Z"
      stroke="var(--primaryColor)"
      strokeWidth="3.14634"
    />
  </Icon>
)
const CheckoutIcon = () => (
  <Icon width="47" height="47" viewBox="0 0 47 47" fill="none">
    <path
      strokeWidth="1"
      stroke="var(--primaryColor)"
      d="M45.4957 10.51C45.0555 9.95519 44.3951 9.63845 43.6831 9.63845H36.746C36.2384 9.63845 35.8251 10.0495 35.8251 10.5594C35.8251 11.067 36.2361 11.4803 36.746 11.4803H43.6831C43.8853 11.4803 44.0043 11.5904 44.056 11.6578C44.1076 11.7229 44.1907 11.8644 44.1436 12.0621L42.9936 17.0398H33.0892C32.5816 17.0398 32.1683 17.4509 32.1683 17.9607C32.1683 18.4684 32.5793 18.8817 33.0892 18.8817H42.5695L41.2848 24.4411H32.5726L32.8921 19.2745C32.928 18.7669 32.5462 18.3267 32.0408 18.2907C31.5332 18.2548 31.0929 18.6366 31.057 19.142L30.7263 24.4389H22.4114L21.1578 17.4225C21.0927 16.9194 20.63 16.5645 20.1269 16.6296C19.6237 16.6948 19.2689 17.1575 19.334 17.6607L20.5561 24.439H12.3556L11.0844 18.8795H20.2369C20.7446 18.8795 21.1578 18.4685 21.1578 17.9586C21.1578 17.4509 20.7468 17.0376 20.2369 17.0376H10.6641L9.39287 11.4782H17.0478C17.5554 11.4782 17.9687 11.0672 17.9687 10.5573C17.9687 10.0496 17.5577 9.63632 17.0478 9.63632H8.97312L8.03199 5.52587C8.02974 5.51688 8.0275 5.50565 8.02525 5.49667C7.63219 4.00972 6.36538 3.01015 4.87177 3.01015H0.920908C0.41328 3.01015 0 3.42119 0 3.93109C0 4.43873 0.411033 4.85202 0.920908 4.85202H4.87177C5.52315 4.85202 6.05995 5.28329 6.24189 5.95265L12.1783 31.9156C11.172 32.0706 10.3679 32.4457 9.78393 33.0365C9.09437 33.7328 8.75075 34.6784 8.76422 35.8464C8.79117 38.5396 9.85355 39.7615 12.4882 39.9884C12.0256 40.6577 11.7538 41.4686 11.7538 42.3446C11.7538 44.6356 13.618 46.5 15.9091 46.5C18.2001 46.5 20.0643 44.6357 20.0643 42.3446C20.0643 41.4888 19.8038 40.6914 19.359 40.0311H28.7454C28.3007 40.6937 28.0401 41.4888 28.0401 42.3446C28.0401 44.6356 29.9044 46.5 32.1954 46.5C34.4864 46.5 36.3507 44.6357 36.3507 42.3446C36.3507 41.4888 36.0901 40.6914 35.6454 40.0311H37.02C37.5276 40.0311 37.9409 39.62 37.9409 39.1101C37.9409 38.6025 37.5299 38.1892 37.02 38.1892H13.4858C12.2392 38.1892 11.4509 38.0207 11.0803 37.6726C10.7636 37.3783 10.6198 36.8078 10.6086 35.8262C10.6018 35.1569 10.7613 34.6672 11.096 34.328C11.6351 33.7845 12.6009 33.6699 13.3174 33.6699H38.4601C39.9785 33.6699 41.2789 32.6367 41.6203 31.1565L45.9396 12.4685C46.0991 11.7744 45.9396 11.0601 45.4994 10.5053L45.4957 10.51ZM30.59 26.2755L30.1902 31.835H23.3688L22.6456 26.2755H30.59ZM14.0435 31.835L12.7722 26.2755H20.7906L21.5138 31.835H14.0435ZM39.8216 30.7478C39.6711 31.3992 39.1209 31.835 38.4538 31.835H32.0344L32.4342 26.2755H40.855L39.8216 30.7478ZM26.8794 20.984C32.5259 20.984 37.1211 16.3906 37.1211 10.742C37.1211 5.09534 32.5278 0.5 26.8794 0.5C21.2329 0.5 16.6377 5.09338 16.6377 10.742C16.6377 16.3887 21.2309 20.984 26.8794 20.984ZM26.8794 2.34101C31.5131 2.34101 35.2796 6.11005 35.2796 10.7415C35.2796 15.373 31.5107 19.142 26.8794 19.142C22.248 19.142 18.4791 15.373 18.4791 10.7415C18.4791 6.11005 22.2481 2.34101 26.8794 2.34101ZM21.3426 10.7554C21.0214 10.3623 21.0798 9.78283 21.4751 9.46163C21.8682 9.14043 22.4477 9.19883 22.7689 9.59415L25.2126 12.5928L30.3558 7.45184C30.7197 7.09695 31.3014 7.10369 31.6563 7.46532C32.0112 7.8292 32.0045 8.41093 31.6429 8.76586L25.7785 14.6097C25.6056 14.7782 25.3742 14.8726 25.1361 14.8726C25.1182 14.8726 25.1025 14.8726 25.0845 14.8703C24.8262 14.8568 24.5859 14.7333 24.4242 14.5334L21.3448 10.7553L21.3426 10.7554Z"
      fill="var(--primaryColor)"
    />
    <circle cx="26.9014" cy="10.7498" r="7.98752" stroke="var(--primaryColor)" strokeWidth="0.675477" />
  </Icon>
)

const ShopAndDeliver = () => (
  <InfoSection title={tStr('shopTitle_s')} tagLine={tStr('shopTagLine_s')}>
    <SectionPanels>
      <Panel title={tStr('shopShoppingTitle_s')} img={<PhoneIcon />}>
        {t('shopShoppingBody_s')}
      </Panel>
      <Panel title={tStr('shopTipsTitle_s')} img={<TipsIcon />}>
        {t('shopTipsBody_s')}
      </Panel>
      <Panel title={tStr('shopCommunityTitle_s')} img={<CommunityIcon />}>
        {t('shopCommunityBody_s')}
      </Panel>
      <Panel title={tStr('shopCheckoutTitle_s')} img={<CheckoutIcon />}>
        {t('shopCheckoutBody_s')}
      </Panel>
    </SectionPanels>
  </InfoSection>
)

export default ShopAndDeliver
